/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthGuard from './components/AuthGuard';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';
import Home from './views/Home';
import PresentationView from './views/Presentation';
import Users from './views/Management/components/Users';
import Operators from './views/Management/components/Operators';
import OperatorDetails from './views/Management/components/OperatorDetails';
import Settings from './views/Management/components/Settings';
import DashboardInspect from './views/Dashboard/components/Inspect/DashboardInspect.js';
import SiteTracker from './views/SiteTracker/components/SiteTracker';
import ReportsKpisOps from './views/ReportsKpisOps/components/ReportsKpisOps';
import ReportsKpisRan from './views/ReportsKpisRan/components/ReportsKpisRan';
import HostTools from './views/HostTools/components/HostTools';
import ScriptsGeneration from './views/ScriptsGeneration/components/ScriptsGeneration';
import BridgeCall from './views/BridgeCall/components/BridgeCall';
import ReportsAcceptance from 'views/ReportsAcceptance/components/ReportsAcceptance';

const routes = [
	{
		path: '/',
		exact: true,
		component: () => <Redirect to="/home" />,
	},
	{
		path: '/home',
		exact: true,
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			// projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Home(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/modules',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/modules/siteTracker',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: SiteTracker()
								}),
							},
							{
								path: '/modules/mergeCoTrackerDashboard',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 1 } }, pageTitle: 'Merge CO Tracker', module: 'Modules' })
								}),
							},
							{
								path: '/modules/bridgeCall',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: BridgeCall()
								}),
							},
							{
								path: '/modules/integrity/dataintegrity',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 2 } }, pageTitle: 'Data Integrity', module: 'Modules' })
								}),
							},
							{
								path: '/modules/integrity/forecastintegrity',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 12 } }, pageTitle: 'Data Integrity', module: 'Modules' })
								}),
							},
							{
								path: '/modules/integrity/processperformancekpis',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 13 } }, pageTitle: 'Data Integrity', module: 'Modules' })
								}),
							},
							{
								path: '/modules/reportsKpisOps',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: ReportsKpisOps()
								}),
							},
							// {
							// 	path: '/modules/reportsKpisRan',
							// 	exact: true,
							// 	component: () => AuthGuard({
							// 		// roles: ['Administrator', 'Manager'],
							// 		children: ReportsKpisRan()
							// 	}),
							// },
							{
								path: '/modules/reportsAcceptance',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: ReportsAcceptance()
								}),
							},
							{
								path: '/modules/hostTools',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: HostTools()
								}),
							},
							{
								path: '/modules/scriptsGeneration',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: ScriptsGeneration()
								}),
							},
							{
								path: '/modules/mergecokpis/vmo2/vmo2standard4g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 7 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/vmo2/vmo2standard5g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 8 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/vdf/vdfstandard4g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 5 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/vdf/vdfstandard5g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 6 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/three/threeukstandard4g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 3 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/three/threeukstandard5g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 4 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/vdf/daily/vdfstandard4g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 14 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/vdf/daily/vdfplmn4g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 15 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/three/daily/threeukstandard4g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 16 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/three/daily/threeukplmn4g',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 17 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/mergeCoKpisStandard',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 9 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								path: '/modules/mergecokpis/acceptance/clusteracceptance',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 10 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							// {
							// 	path: '/modules/mergecokpis/acceptance/rollback',
							// 	exact: true,
							// 	component: () => AuthGuard({
							// 		// roles: ['Administrator', 'Manager'],
							// 		children: DashboardInspect({ match: { params: { id: 11 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
							// 	}),
							// },
							{
								path: '/modules/mergecokpis/acceptance/rollback',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 18 } }, pageTitle: 'Merged CO KPIS', module: 'Modules' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/dashboards',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/dashboards/DashboardOne',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 2 } }, pageTitle: 'Test', module: 'Dashboards' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/management',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/management/operators',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Operators()
								}),
							},
							{
								path: '/management/operators/details',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: OperatorDetails()
								}),
							},
							{
								path: '/management/users',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Users(),
								}),
							},
							{
								path: '/management/settings',
								exact: true,
								component: () => AuthGuard({
									children: Settings()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),

	},
	{
		path: '/auth',
		component: AuthLayout,
		routes: [
			{
				path: '/auth/login',
				exact: true,
				component: lazy(() => import('views/Auth/Login')),
			},
			{
				path: '/auth/completeregistration',
				exact: true,
				component: lazy(() => import('views/Auth/CompleteRegistration')),
			},
			{
				path: '/auth/resetpassword',
				exact: true,
				component: lazy(() => import('views/Auth/ResetPassword')),
			},
			{
				path: '/auth/requestAccess',
				exact: true,
				component: lazy(() => import('views/Auth/RequestAccess')),
			},
			{
				path: '/auth/requestAccessConfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RequestAccessConfirmation')),
			},
			{
				path: '/auth/recover',
				exact: true,
				component: lazy(() => import('views/Auth/Recover')),
			},
			{
				path: '/auth/recoverconfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RecoverConfirmation')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
	{
		path: '/errors',
		component: ErrorLayout,
		routes: [
			{
				path: '/errors/error-401',
				exact: true,
				component: lazy(() => import('views/Error401')),
			},
			{
				path: '/errors/error-404',
				exact: true,
				component: lazy(() => import('views/Error404')),
			},
			{
				path: '/errors/error-500',
				exact: true,
				component: lazy(() => import('views/Error500')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
	{
		path: '*',
		component: () => AuthGuard({
			roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout({
				route: {
					routes: [
						{
							path: '/notifications',
							exact: true,
							component: lazy(() => import('views/Notifications')),
						},
						{
							component: () => <Redirect to="/errors/error-404" />,
						},
					],
				},
			})
		}),
	},
];

export default routes;
